/**
* @Author: Matthias Gohla <Matze>
* @Date:   2016-09-21T09:28:14+02:00
* @Email:  matze_lebt@gmx.de
* @Last modified by:   Matze
* @Last modified time: 2016-09-22T11:17:50+02:00
*/


import React, {Component} from 'react';
import PropTypes from 'prop-types';

/**
 * MStepperCheckout - …
**/
class MStepperCheckout extends Component {
  /**
     * TODO jsdoc
     *
     * @return {object}
     */
  render() {
    const {
      children,
    } = this.props;
	 return (
	        <div className="m-stepper m-stepper-checkout">
	            {children}
	        </div>
	    );
  }
}

MStepperCheckout.propTypes = {
  /**
     * should be the AStepCheckout component
     */
  children: PropTypes.any,
};
MStepperCheckout.defaultProps = {};
export default MStepperCheckout;

